var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHydroelectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3b9cf8",
    d: "M63 11v53H1V11h8v4h46v-4z",
    opacity: 1,
    "data-original": "#3b9cf8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c75ba",
    d: "M23 35H13V23h10zm14-12H27v12h10zm14 0H41v12h10z",
    opacity: 1,
    "data-original": "#2c75ba",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39c5ee",
    d: "M1 64v-5a6.005 6.005 0 0 1 6.104-5.999C6.991 49.729 9.727 47.058 13 47V34a5 5 0 0 1 10 0v11c1.63 0 3.09.79 4 2V34a5 5 0 0 1 10 0v13c.91-1.21 2.37-2 4-2V34a5 5 0 0 1 10 0v13c3.273.058 6.009 2.729 5.896 6.001A6.005 6.005 0 0 1 63 59v5",
    opacity: 1,
    "data-original": "#39c5ee",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 11,
    fill: "#f2d57e",
    opacity: 1,
    "data-original": "#f2d57e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbb03b",
    d: "M36 5h-6l-2 8h2l-1 6 7-9h-2z",
    opacity: 1,
    "data-original": "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9f9fb",
    d: "M4 59h2v2H4zm53 1h2v-2h-2zm-21-9v2h2v-2zm10-5v2h2v-2zm-28 5h-2v2h2zm24 9h2v-2h-2zM17 45V34a2 2 0 1 0-4 0v11a2 2 0 1 0 4 0zm14 0V34a2 2 0 1 0-4 0v11a2 2 0 1 0 4 0zm14 0V34a2 2 0 1 0-4 0v11a2 2 0 1 0 4 0z",
    opacity: 1,
    "data-original": "#c9f9fb",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#282846"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 10h-8a1 1 0 0 0-1 1v3H43.819c.11-.652.181-1.317.181-2 0-6.617-5.383-12-12-12S20 5.383 20 12c0 .683.071 1.348.181 2H10v-3a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v53h2v-5a4.96 4.96 0 0 1 1.496-3.564 5.005 5.005 0 0 1 3.592-1.435c.246.02.538-.104.73-.299.191-.196.295-.461.285-.735-.043-1.248.42-2.448 1.304-3.379a5.132 5.132 0 0 1 3.61-1.587c.546-.011.983-.456.983-1.001V34c0-2.206 1.794-4 4-4s4 1.794 4 4v11a1 1 0 0 0 1 1 4.03 4.03 0 0 1 3.201 1.601A1 1 0 0 0 28 47V34c0-2.206 1.794-4 4-4s4 1.794 4 4v13a1 1 0 0 0 1.799.601A4.03 4.03 0 0 1 41 46a1 1 0 0 0 1-1V34c0-2.206 1.794-4 4-4s4 1.794 4 4v13a1 1 0 0 0 .982 1 5.13 5.13 0 0 1 3.61 1.587c.884.932 1.347 2.132 1.304 3.379a1 1 0 0 0 .285.735c.192.196.505.301.73.299 1.351-.011 2.626.486 3.592 1.435S62 57.65 62 59v5h2V11a1 1 0 0 0-1-1zm-9 6v6H38.619a12.047 12.047 0 0 0 4.681-6zM32 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10S26.486 2 32 2zM20.7 16a12.047 12.047 0 0 0 4.681 6H10v-6zM6.144 52.052a6.95 6.95 0 0 0-4.05 1.958c-.033.032-.062.068-.094.102V12h6v36.171c-.014.014-.03.025-.044.039a6.67 6.67 0 0 0-1.812 3.842zM12 46.087a7.139 7.139 0 0 0-2 .647V24h2zM18 28a5.97 5.97 0 0 0-4 1.54V24h8v5.54A5.97 5.97 0 0 0 18 28zm8 16.809a6.017 6.017 0 0 0-2-.723V24h2zM32 28a5.97 5.97 0 0 0-4 1.54V24h8v5.54A5.97 5.97 0 0 0 32 28zm8 16.085a6.04 6.04 0 0 0-2 .723V24h2zM46 28a5.97 5.97 0 0 0-4 1.54V24h8v5.54A5.97 5.97 0 0 0 46 28zm6-4h2v22.734a7.172 7.172 0 0 0-2-.647zm9.906 30.01a6.945 6.945 0 0 0-4.05-1.958 6.662 6.662 0 0 0-1.813-3.841c-.014-.014-.03-.025-.044-.039V12h6v42.112c-.031-.034-.06-.07-.093-.102z",
    fill: "#282846",
    opacity: 1,
    "data-original": "#282846",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 51a8.951 8.951 0 0 0-7.804 4.531A4.937 4.937 0 0 0 35 55c-.434 0-.847.073-1.249.177C32.946 52.2 30.228 50 27 50c-3.547 0-6.479 2.654-6.932 6.08a5.96 5.96 0 0 0-2.555 1.047C16.838 55.868 15.526 55 14 55c-2.206 0-4 1.794-4 4h2c0-1.103.897-2 2-2 1.012 0 1.842.758 1.973 1.735A5.96 5.96 0 0 0 15 62h2c0-2.206 1.794-4 4-4s4 1.794 4 4h2c0-2.936-2.12-5.381-4.909-5.896C22.515 53.775 24.55 52 27 52c2.449 0 4.483 1.773 4.909 4.101C30.755 57.017 30 58.415 30 60h2c0-1.654 1.346-3 3-3s3 1.346 3 3h2c0-1.229-.463-2.341-1.201-3.212A6.957 6.957 0 0 1 45 53c3.859 0 7 3.14 7 7h2c0-4.962-4.037-9-9-9zM28 14h.819l-.806 4.835A1.002 1.002 0 0 0 29 20a.996.996 0 0 0 .789-.386l7-9A1 1 0 0 0 36 9h-.523l1.452-3.628A1 1 0 0 0 36 4h-6c-.459 0-.858.313-.97.757l-2 8A.998.998 0 0 0 28 14zm2.781-8h3.742l-1.452 3.628a1 1 0 0 0 .885 1.37l-3.32 4.269.351-2.104A.996.996 0 0 0 30 12h-.719z",
    fill: "#282846",
    opacity: 1,
    "data-original": "#282846",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydroelectric);
export default __webpack_public_path__ + "static/media/hydroelectric.d205ab3e7d28c989382140377da8c35c.svg";
export { ForwardRef as ReactComponent };